'use client';
import OtpInput from 'react-otp-input';
import Typography from '@/components/shared/typography/typography.component';
import { useEffect, useState } from 'react';
import { useSendOtpMutation } from '@/hook/slices/otp-api-slice';
import { useTranslation } from '@/hook';
import styles from './styles.module.scss';

interface ISellCarOtp {
    mobile: string;
    errorType: string;
    otpError: boolean;
    setOtpValue: (otp: string) => void;
}

const SellCarOtp = ({
    mobile,
    errorType,
    otpError,
    setOtpValue,
}: ISellCarOtp) => {
    const [OTP, setOTP] = useState('');
    const [count, setCount] = useState(30);
    const [otpResended, setOtpResended] = useState(false);

    const { i18n, t } = useTranslation();
    const lang = i18n.language;

    const [sendOtp] = useSendOtpMutation();

    const onResendClicked = e => {
        e.preventDefault();
        if (!otpResended) {
            sendOtp(mobile);
            setCount(30);
            setOtpResended(true);
        }
    };
    useEffect(() => {
        const interval = setInterval(() => {
            setCount(value => (value > 0 ? value - 1 : 0));
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (OTP.length === 6) setOtpValue(OTP);
    }, [OTP]);

    return (
        <div dir="ltr" style={{ textAlign: lang === 'en' ? 'left' : 'right' }}>
            <OtpInput
                renderInput={props => (
                    <input
                        {...props}
                        className={styles.otp_input}
                        maxLength={1}
                        type="number"
                    />
                )}
                value={OTP}
                onChange={setOTP}
                numInputs={6}
                inputType="number"
                shouldAutoFocus
            />

            {otpError ? (
                <Typography
                    style={{
                        color: 'error.main',
                        textAlign: lang === 'en' ? 'left' : 'right',
                    }}
                >
                    {errorType === 'duplicate'
                        ? `${t('verificationErrorDuplicateEntry')}`
                        : `${t('verificationError')}`}
                </Typography>
            ) : null}
            <Typography
                variant="body2Medium"
                style={{
                    color: '#8B959E',
                    textAlign: lang === 'en' ? 'left' : 'right',
                }}
            >
                {t('OTPCodeValidFor')}{' '}
            </Typography>

            <button disabled={count !== 0} onClick={onResendClicked}>
                <Typography
                    variant="body2"
                    style={{
                        color: count === 0 ? '#173059' : '#c4cedd',
                        textDecoration: 'underline',
                    }}
                >
                    {t('ResendOTP')} {count !== 0 ? `(${count})` : ''}
                </Typography>
            </button>
        </div>
    );
};
export default SellCarOtp;
